/* eslint-disable */
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const nameItemText = "Solución de Limpieza";
//
// ########################################################################### 
//
const ValorSolucionLimpiezaDialog = ({
  onClose,
  articuloData
}) => {
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Ver {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="codigo"
                label="Código"
                variant="outlined"
                size="small"
                name="codigo"
                value={articuloData.codigo}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={articuloData.descripcion}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionSlMarca"
                label="Marca"
                variant="outlined"
                size="small"
                name="descripcionSlMarca"
                value={articuloData.descripcionSlMarca}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionSlIndicacion"
                label="Indicación"
                variant="outlined"
                size="small"
                name="descripcionSlIndicacion"
                value={articuloData.descripcionSlIndicacion}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionSlPresentacion"
                label="Presentación"
                variant="outlined"
                size="small"
                name="descripcionSlPresentacion"
                value={articuloData.descripcionSlPresentacion}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="descripcionSlLaboratorio"
                label="Laboratorio"
                variant="outlined"
                size="small"
                name="descripcionSlLaboratorio"
                value={articuloData.descripcionSlLaboratorio}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="ultimoCosto"
                label="Último Costo $"
                variant="outlined"
                size="small"
                name="ultimoCosto"
                value={articuloData.ultimoCosto ? articuloData.ultimoCosto.toFixed(2) : "0.00"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="fechaUltimoCosto"
                label="Fecha Último Costo"
                variant="outlined"
                size="small"
                name="fechaUltimoCosto"
                value={articuloData.fechaUltimoCosto ? articuloData.fechaUltimoCosto : " "}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="valorDolarUltimo"
                label="Valor U$S Último"
                variant="outlined"
                size="small"
                name="valorDolarUltimo"
                value={articuloData.valorDolarUltimo ? articuloData.valorDolarUltimo.toFixed(2) : "0.00"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="ultimoCostoEnDolar"
                label="Último Costo en U$S"
                variant="outlined"
                size="small"
                name="ultimoCostoEnDolar"
                value={articuloData.ultimoCostoEnDolar ? articuloData.ultimoCostoEnDolar.toFixed(2) : "0.00"}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="actualCosto"
                label="Costo Actual $"
                variant="outlined"
                size="small"
                name="actualCosto"
                value={articuloData.actualCosto ? articuloData.actualCosto.toFixed(2) : "0.00"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="fechaActualCosto"
                label="Fecha Costo Actual"
                variant="outlined"
                size="small"
                name="fechaActualCosto"
                value={articuloData.fechaActualCosto ? articuloData.fechaActualCosto : " "}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="valorDolarActual"
                label="Valor Actual U$S"
                variant="outlined"
                size="small"
                name="valorDolarActual"
                value={articuloData.valorDolarActual ? articuloData.valorDolarActual.toFixed(2) : "0.00"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="actualCostoEnDolar"
                label="Costo Actual en U$S"
                variant="outlined"
                size="small"
                name="actualCostoEnDolar"
                value={articuloData.actualCostoEnDolar ? articuloData.actualCostoEnDolar.toFixed(2) : "0.00"}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="previoVentaContado"
                label="PV Contado $"
                variant="outlined"
                size="small"
                name="previoVentaContado"
                value={articuloData.previoVentaContado ? articuloData.previoVentaContado.toFixed(2) : "0.00"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="futContado"
                label="Factor Utilidad Contado"
                variant="outlined"
                size="small"
                name="futContado"
                value={articuloData.futContado ? articuloData.futContado.toFixed(4) : "0.00"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="precioVentaLista"
                label="PV Lista $"
                variant="outlined"
                size="small"
                name="precioVentaLista"
                value={articuloData.precioVentaLista ? articuloData.precioVentaLista.toFixed(2) : "0.00"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                sx={{ width: "100%", mb: 1 }}
                id="futLista"
                label="Factor Utilidad Lista"
                variant="outlined"
                size="small"
                name="futLista"
                value={articuloData.futLista ? articuloData.futLista.toFixed(4) : "0.00"}
                disabled={true}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            sx={{ mr: 2 }}
            variant="outlined"
            size="small"
            onClick={handleCloseDialog}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ValorSolucionLimpiezaDialog;
